import { Navigate } from "react-router-dom";
import { usePapeleraPermissions } from "./usePapeleraPermissions";

export default function PapeleraIndexRedirect() {
  const { manageableEntities } = usePapeleraPermissions();
  const first = manageableEntities[0];
  if (!first) return <Navigate to="/" replace />;
  return <Navigate to={first.id} replace />;
}
